import { EditModalComponent } from './edit-modal.component';
import { CommonModule } from '@angular/common';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CollapseModule } from 'ngx-bootstrap';
import { PostalCodeInputModule } from '@blcloud/bl-ng-share-module';
import { ModuleWithProviders, NgModule } from '@angular/core';

@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    CollapseModule,
    PostalCodeInputModule,
  ],
  exports: [
    EditModalComponent
  ],
  declarations: [
    EditModalComponent
  ],
  entryComponents: [
    EditModalComponent
  ],
  providers: [
  ]
})
export class EditModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: EditModalModule,
      providers: [
        CollapseModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/page/contact-list-page/modal/edit-modal.module.ts